module.exports = __webpack_public_path__ + "static/media/gate.fc212ec7.png";